import axiosInstance from "./AxiosInstance";

export function getDiseaseMedicineMappings(pagination, pageid,search_by = "", search_keyword = "", sort_by = "",sort_order = "") {
  return axiosInstance.post("/admin/medicineDisease", {pagination, pageid ,search_by, search_keyword, sort_by, sort_order});
}

export function createDiseaseMedicineMapping(mappingData) {
  return axiosInstance.post("/admin/medicineDiseaseAdd", mappingData);
}

export function updateDiseaseMedicineMapping(mappingData) {
  return axiosInstance.post("/admin/editMapping", mappingData);
}

export function deleteDiseaseMedicineMapping(mapping) {
  return axiosInstance.post("/admin/deleteMapping", mapping);
}

export function formatDiseaseMedicineMappings(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((m) => ({
      ...m,
      disease_medicine_id: m.disease_medicine_id || m._id || m.id,
    }));
  }

  return Object.entries(responseData).map(([key, m]) => ({
    ...m,
    disease_medicine_id: m.disease_medicine_id || m._id || m.id || key,
  }));
}
// export function formatDiseaseMedicineMappings(responseData) {
//   if (!responseData) return [];

//   console.log("Original responseData length:", responseData.length);

//   if (Array.isArray(responseData)) {
//     const formatted = responseData
//       .map((m, index) => {
//         if (!m || typeof m !== "object") {
//           console.warn(`Invalid mapping at index ${index}:`, m);
//           return null;
//         }

//         return {
//           ...m,
//           disease_medicine_id: m.disease_medicine_id || m._id || m.id,
//         };
//       })
//       .filter(Boolean); // removes nulls

//     console.log("Formatted mappings length:", formatted.length);
//     return formatted;
//   }

//   // fallback in case it's an object instead of array
//   const formatted = Object.entries(responseData).map(([key, m]) => ({
//     ...m,
//     disease_medicine_id: m.disease_medicine_id || m._id || m.id || key,
//   }));
//   console.log("Formatted object entries length:", formatted.length);
//   return formatted;
// }
